import client from '../client';

const USERS = {
  signIn(params) {
    return client.post(`/sessions`, { user: params }, { withCredentials: true })
  },

  createUser(params) {
    return client.post(`/radar/sign_up`, { user: params }, { withCredentials: true })
  },
}

export default USERS;
